// src/config.ts

// const BASE_URL = "http://localhost:13380/api";
const HOST = window.location.hostname;
const PORT = HOST === "localhost" ? "13380" : "443"; // Use 443 for production, 13380 for local development
const PROTOCOL = window.location.protocol;
const BASE_URL = `${PROTOCOL}//${HOST}:${PORT}/api`;
// const BASE_URL = "http://192.168.34.13:3000/api";

export const API = {
  BASE_URL,
  SENSORS: `${BASE_URL}/sensors`,
  LOGIN: `${BASE_URL}/login`,
  RESET_PASSWORD: `${BASE_URL}/reset_password`,
  PROFILE: `${BASE_URL}/profile`,
  USERS: `${BASE_URL}/users`,
  SECTIONS: `${BASE_URL}/sections`,
  RECORD: (account: string) => `${BASE_URL}/record/${encodeURIComponent(account)}`,
  COUNTERS_UPDATE: (account: string) => `${BASE_URL}/counters/${encodeURIComponent(account)}`,
  USER: (account: string) => `${BASE_URL}/user/${encodeURIComponent(account)}`,
  RESET_PASSWORD_USER: (account: string) => `${BASE_URL}/user_reset_password/${encodeURIComponent(account)}`,
  DOC_HELP: `${BASE_URL}/doc/help`,
  DOC_TELEGRAM: `${BASE_URL}/doc/telegram`,
  DOC_REQUISITE: `${BASE_URL}/doc/requisite`,
  MARKDOWN: (group: string, id: string) => `${BASE_URL}/markdown/${encodeURIComponent(group)}/${encodeURIComponent(id)}`,
  MARKDOWN_POST: (group: string, id: string, postId: string) => `${BASE_URL}/markdown/${encodeURIComponent(group)}/${encodeURIComponent(id)}/${encodeURIComponent(postId)}`,
};

